// extracted by mini-css-extract-plugin
module.exports = {"people":"team_people__OFZNZ","person":"team_person__2fSLP","person__name":"team_person__name__3LKGK","person__title":"team_person__title__13jF0"};